import { computed } from '@angular/core';
import { patchState, signalStoreFeature, withComputed, withMethods, withState } from '@ngrx/signals';

export type RequestStatus = 'idle' | 'pending' | 'fulfilled' | { error: string; };

export type RequestStatusState = { requestStatus: RequestStatus; };

export function withRequestStatus() {
  return signalStoreFeature(
    withState<RequestStatusState>({ requestStatus: 'idle' }),
    withComputed(({ requestStatus }) => ({
      error: computed(() => {
        const status = requestStatus();

        return typeof status === 'object' ? status.error : null;
      }),
      isFulfilled: computed(() => requestStatus() === 'fulfilled'),
      isPending: computed(() => requestStatus() === 'pending'),
    })),
    withMethods((store) => ({
      setError(error: string) {
        patchState(store, { requestStatus: { error } });
      },

      setFulfilled() {
        patchState(store, { requestStatus: 'fulfilled' });
      },

      setPending() {
        patchState(store, { requestStatus: 'pending' });
      },
    })),
  );
}
